module.exports = __webpack_public_path__ + "static/media/biddisable.3e5227df.svg";